import { render, staticRenderFns } from "./Advances.vue?vue&type=template&id=fe81f28c&"
import script from "./Advances.vue?vue&type=script&setup=true&lang=js&"
export * from "./Advances.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports